import template from './optimumidlist.html';
import controller from './optimumidlist.controller';
import './optimumidlist.scss';

let optimumidlistComponent = {
  restrict: 'E',
  bindings: {
    btnClass: '@',
    items: '=',
    itemsLength: '@',
    title: '=',
    itemClickHandler: '=',
    nextComponentHandler: '=',
    prevComponentHandler: '=',
    listId: '@',
    labelField: '@',
    upIsPrev: '@',
    downIsNext: '@'
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default optimumidlistComponent;



// WEBPACK FOOTER //
// ./client/app/components/optimumidlist/optimumidlist.component.js